import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#595959",
  "fill-rule": "evenodd",
  d: "M4 3.667a.5.5 0 0 1 .5.5V5.5a.5.5 0 0 1-1 0V4.167a.5.5 0 0 1 .5-.5ZM6.667 3.667a.5.5 0 0 1 .5.5V5.5a.5.5 0 1 1-1 0V4.167a.5.5 0 0 1 .5-.5Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#595959",
  "fill-rule": "evenodd",
  d: "M2.063 2.063c.89-.89 2.22-1.23 3.937-1.23h4c1.716 0 3.047.34 3.937 1.23.89.89 1.23 2.221 1.23 3.937v4c0 1.716-.34 3.047-1.23 3.937-.89.89-2.221 1.23-3.937 1.23H6c-1.716 0-3.047-.34-3.937-1.23-.89-.89-1.23-2.221-1.23-3.937V6c0-1.716.34-3.047 1.23-3.937Zm.707.707c-.61.61-.937 1.613-.937 3.23v4c0 1.617.327 2.62.937 3.23.61.61 1.612.937 3.23.937h4c1.617 0 2.62-.327 3.23-.937.61-.61.936-1.613.936-3.23V6c0-1.617-.326-2.62-.936-3.23-.61-.61-1.613-.937-3.23-.937H6c-1.618 0-2.62.327-3.23.937Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#595959",
  "fill-rule": "evenodd",
  d: "M4 10.167a.5.5 0 0 1 .5.5V12a.5.5 0 0 1-1 0v-1.333a.5.5 0 0 1 .5-.5ZM6.667 10.167a.5.5 0 0 1 .5.5V12a.5.5 0 0 1-1 0v-1.333a.5.5 0 0 1 .5-.5ZM8.833 4.833a.5.5 0 0 1 .5-.5H12a.5.5 0 0 1 0 1H9.333a.5.5 0 0 1-.5-.5ZM8.833 11.333a.5.5 0 0 1 .5-.5H12a.5.5 0 0 1 0 1H9.333a.5.5 0 0 1-.5-.5ZM.833 8a.5.5 0 0 1 .5-.5h13.333a.5.5 0 0 1 0 1H1.333a.5.5 0 0 1-.5-.5Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }